import { Disclosure } from "@headlessui/react";
import { ChevronDoubleDownIcon } from "@heroicons/react/24/solid";
import React from "react";
import useGetItemizedByInvoiceDetailsId from "../hooks/useGetItemizedByInvoiceDetailsId";
import InvoiceDebitAdjustmentDetails from "../../InvoiceCapture/view/InvoiceDebitAdjustmentDetails";

interface IProps {
  data;
}

const DebitAdjusmentView: React.FC<IProps> = ({ data }) => {
  const args = data?.invoiceDetailsId ?? 0;
  const { isFetching: isLoading } = useGetItemizedByInvoiceDetailsId(args);

  return (
    <>
      {/* Debit Adjusment Section */}
      <div className={"w-full bg-white p-2 overflow-x-auto shadow-md rounded"}>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <div className="m-2 bg-white rounded-lg shadow-lg">
                <div className="flex flex-row items-center justify-between">
                  <div className="text-base text-pink-500 font-bold font-sans py-2 px-3">
                    Debit Adjustment
                  </div>
                  <div>
                    <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                      <div className="flex flex-row justify-end">
                        <div className="text-base flex flex-row mr-4">
                          <label className="text-quinary font-bold font-sans mr-2">
                            Bill Adjustment:
                          </label>
                          <div className="bg-gray-100 border-gray-100 rounded shadow-md">
                            <label className="text-black font-bold font-sans ml-2 mr-2">
                              $
                              {data.billAdjustment.length > 0
                                ? data.billAdjustment.reduce(
                                    (bill, adj) => bill + adj,
                                    0
                                  )
                                : data.billAdjustment[0]}
                            </label>
                          </div>
                        </div>
                        <ChevronDoubleDownIcon
                          className={`${
                            open ? "transform rotate-180" : ""
                          }  text-gray-500 w-5 h-5 mr-4`}
                        />
                      </div>
                    </Disclosure.Button>
                  </div>
                </div>
                <Disclosure.Panel className="text-xxs">
                  <InvoiceDebitAdjustmentDetails
                    rowData={data?.debitAdjustmentDetails}
                    isLoading={isLoading}
                  />
                </Disclosure.Panel>
                <div className="text-base flex flex-row justify-end py-2 px-3 mr-8">
                  <div className="bg-gray-100 border-4 border-gray-100 rounded shadow-md">
                    <label className="text-quinary font-bold font-sans ml-2 mr-2">
                      Total Amount Paid:
                    </label>
                    <label className="text-black font-bold font-sans mr-2">
                      {data.billAdjustment.length > 0
                        ? "$" +
                          (data.amountPaid -
                            data.billAdjustment.reduce(
                              (bill, adj) => bill + adj,
                              0
                            ))
                        : "$"}
                    </label>
                  </div>
                </div>
              </div>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
};

export default DebitAdjusmentView;
